<template>
    <b-badge pill :variant="variant">
        {{ name }}
    </b-badge>
</template>

<script>
export default {
  props: {
    status: {
      type: Number,
      required: true,
      validator: (val) => [1, 2].includes(val)
    }
  },
  computed: {
    variant () {
      const variants = {
        1: 'primary',
        2: 'secondary'
      }

      return variants[this.status]
    },
    name () {
      const names = {
        1: 'Новое',
        2: 'Закрыто'
      }

      return names[this.status]
    }
  }
}
</script>

<style scoped>
    .badge {
        font-weight: normal;
    }
</style>
